export default __webpack_public_path__ + "static/media/RSS.cae5fde0.png";